import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button, Icon } from 'gu-ui-kit'
import { TOGGLE_PANEL } from 'modules/Tickets/types'
import styles from 'components/Header/subcomponents/TicketsCounter/ticket-notifications.module.scss'

const TicketsCounter = () => {
  const dispatch = useDispatch()
  const { ticketsCounter } = useSelector(({ app }) => app)

  return (
    <Button
      className={styles['tickets-button']}
      variant={'ghost'}
      grey
      size={'s'}
      startIcon={<Icon name={'messages'} />}
      onClick={() => dispatch({ type: TOGGLE_PANEL, payload: true })}
      additionalIcon={
        ticketsCounter > 0 && <span className="unread">{ticketsCounter}</span>
      }
    />
  )
}

export default TicketsCounter
